import Select from "react-select";
import styled from "styled-components";

export const SelectStyles = styled(Select)`
    & > div{
        padding: 3px 0 0 0;
        cursor: pointer;
    };

    & > div > div > div {
        cursor: pointer;
    };
`;